import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../env";

const GeneratePDFButton = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGeneratePDF = async () => {
    const bookingId = "67550";
    setLoading(true);
    setError("");

    try {
      const response = await axios.get(`${REACT_APP_API_URL}/api/generate-pdf`, {
        params: { bookingId },
        responseType: "blob", 
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice-${bookingId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error("Error:", err);
      setError("PDF generation failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>Invoice PDF Generator</h2>
      <button
        onClick={handleGeneratePDF}
        disabled={loading}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: loading ? "not-allowed" : "pointer",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px"
        }}
      >
        {loading ? "Generating PDF..." : "Download Invoice PDF"}
      </button>
      {error && <p style={{ color: "red", marginTop: "20px" }}>{error}</p>}
    </div>
  );
};

export default GeneratePDFButton;
